// extracted by mini-css-extract-plugin
export default {"container":"Heading_container__79Uvg","button":"Heading_button__OsaxM"};